import { render, staticRenderFns } from "./join.vue?vue&type=template&id=48b3728e&scoped=true"
import script from "./join.vue?vue&type=script&lang=js"
export * from "./join.vue?vue&type=script&lang=js"
import style0 from "./join.vue?vue&type=style&index=0&id=48b3728e&prod&lang=scss&scoped=true"
import style1 from "./join.vue?vue&type=style&index=1&id=48b3728e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b3728e",
  null
  
)

export default component.exports